import { render, staticRenderFns } from "./scrollBoardRight.vue?vue&type=template&id=b4141158"
import script from "./scrollBoardRight.vue?vue&type=script&lang=js"
export * from "./scrollBoardRight.vue?vue&type=script&lang=js"
import style0 from "./scrollBoardRight.vue?vue&type=style&index=0&id=b4141158&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports